<template>
  <div>
    <QrCode ref="qrCode"></QrCode>
    <section class="main-other-qa">
      <div class="main-center container">
        <div class="content">
          <div class="left">
            <h6>Help&Support</h6>
            <p class="f-medium">Need Help?</p>
            <div class="zx-btn">
              <a href="javascript:void(0)" @click="showChatQr" class="b"><span>Chat Now</span></a>
            </div>
          </div>
          <div class="right">
            <div>
              <p class="f-medium">LightCourse Student Services</p>
              <!-- mailto:studentservice@lightglobal.org -->
              <a href="javascript:void(0)" @click="copyText('studentservice@lightglobal.org')" class="copy-btn-01"><strong class="copy-txt-01">studentservice@lightglobal.org</strong></a>
            </div>
            <div>
              <p class="f-medium">Collaborate With Us</p>
              <!-- mailto:partnerships@lightglobal.org -->
              <a href="javascript:void(0)" @click="copyText('collaborate@lightglobal.org')" class="copy-btn-02"><strong class="copy-txt-02">collaborate@lightglobal.org</strong></a>
            </div>
          </div>
        </div>
      </div>
    </section>
	</div>
</template>

<script>
import QrCode from "../Contact/QrCode";

  export default {
    props: {

    },
    components:{
      QrCode
    },
    data(){
      return{
        updateYear: null,
      }
    },
    created() {
      let copyright = new Date();
      this.updateYear = copyright.getFullYear();
    },
    methods: {
      copyText(value) {
        let input = document.createElement("input"); // 创建input对象
        input.value = value; // 设置复制内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        layer.msg("Copy Succeeded");
      },
      showChatQr() {
        this.$refs.qrCode.showChatQr();
      },
    }
  }
</script>

<style scoped>
  @media screen and (max-width: 900px) {
    .main-other-qa .container .content .right {
      justify-content: space-around;
    }
    .main-other-qa .container .content .left {
      text-align: center;
      margin-bottom: 10px;
    }
    .main-other-qa .container .content .right {
      width: 26rem;
    }
  }
    .copy-btn-01,
    .copy-btn-02{
      transition: all .6s;
    }
    .copy-btn-01:hover,
    .copy-btn-02:hover{
      color: #00db6d !important;
    }
  .setBetween .item:nth-of-type(1):after {
    content: '';
    display: block;
    width: 1px;
    height: 100%;
    background: #3b52f6;
    position: absolute;
    right: 0;
    top: 0;
  }

  .setBetween .item {
    width: 50%;
  }

  .setBetween .item:nth-of-type(1) {
    padding-right: 20px !important;
    position: relative;
  }

  .setBetween .item:nth-of-type(2) {
    padding-right: 20px !important;
  }

  .setBetween .item:nth-of-type(1):after {
    width: 0px;
  }

  .a-line {
    padding-bottom: 0.8rem;
  }

  .a-btn {
    background: #3b52f6;
    /*display: inline-block;*/
    text-align: center;
    height: 3rem;
    line-height: 3rem;
    color: white;
  }

  .a-btn a {
    color: white !important;
    display: block;
    width: 100%;
    height: 100%;
  }

  .a-blue {
    color: #3b52f6;
  }

  .add-btn {
    text-align: right;
  }

  .add-btn a {
    border-radius: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/ChatFooter.vue